import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-pagina-nao-encontrada",
  templateUrl: "./pagina-nao-encontrada.component.html",
  styleUrls: ["./pagina-nao-encontrada.component.scss"],
})
export class PaginaNaoEncontradaComponent implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute) {
    if (router.url.search("/videos/sp/") >= 0) {
      const split = router.url.split("videos/sp/");

      if (split.length < 1) {
        return;
      }

      const numeroLaudoEncode = encodeURIComponent(split[1]);
      this.router.navigateByUrl("videos/sp/" + numeroLaudoEncode);
    } else if (router.url.search("/agendamentovistorias/go/") >= 0) {
      const split = router.url.split("agendamentovistorias/go/");

      if (split.length < 1) {
        return;
      }

      const localCnpjEncoded = encodeURIComponent(split[1]);
      this.router.navigateByUrl("agendamentovistorias/go/" + localCnpjEncoded);
    } else if (router.url.search("/agendamentovistorias/mt/") >= 0) {
      const split = router.url.split("agendamentovistorias/mt/");

      if (split.length < 1) {
        return;
      }

      const localCnpjEncoded = encodeURIComponent(split[1]);
      this.router.navigateByUrl("agendamentovistorias/mt/" + localCnpjEncoded);
    } else if (router.url.search("/agendamentovistorias/es/") >= 0) {
      const split = router.url.split("agendamentovistorias/es/");

      if (split.length < 1) {
        return;
      }

      const localCnpjEncoded = encodeURIComponent(split[1]);
      this.router.navigateByUrl("agendamentovistorias/es/" + localCnpjEncoded);
    } else if (router.url.search("/agendamentovistorias/mg/") >= 0) {
      const urlSplit = router.url.split("agendamentovistorias/mg/");

      if (urlSplit.length < 1) {
        return;
      }

      let cnpj = urlSplit[1];
      let navegacao = "";

      if (urlSplit[1].split("/agendamento").length > 1) {
        cnpj = urlSplit[1].split("/agendamento")[0];
        navegacao = urlSplit[1].split(cnpj)[1];
      }

      if (urlSplit[1].split("/consulta").length > 1) {
        cnpj = urlSplit[1].split("/consulta")[0];
        navegacao = urlSplit[1].split(cnpj)[1];
      }

      const cnpjEncoded = encodeURIComponent(cnpj);
      this.router.navigateByUrl(
        "agendamentovistorias/mg/" + cnpjEncoded + navegacao
      );
    }
  }

  ngOnInit() {}
}
